// extracted by mini-css-extract-plugin
export default {"bsepa":"playMenu_bsepa__ghkx4"};